var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-picwall"},[_c('el-image',{attrs:{"fit":"fill","src":_vm.pic},on:{"click":_vm.goForward}}),_vm._t("btn"),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }